/* eslint-disable */
import { ErrorHelper } from "../../helpers/ErrorHelper";
import { WebApi } from "@/services/WebApi";

const state = () => ({
    countryFormatCaches: []
})

const getters = {
    findCountryFormatCache: (state) => key => state.countryFormatCaches.find(cfc => cfc.key === key)
}

const mutations = {
    setLoading(state, { key, loading }) {
        const existing = state.countryFormatCaches.find(cfc => cfc.key === key);
        if (!!existing) {
            existing.loading = !!loading;
            existing.retry = false;
        } else {
            state.countryFormatCaches.push({ key: key, value: null, loading: !!loading });
        }
    },
    setCountryFormat(state, { key, countryFormat }) {
        const existing = state.countryFormatCaches.find(cfc => cfc.key === key);
        if (!!existing) {
            existing.value = countryFormat;
            existing.loading = false;
            existing.loaded = true;
        } else {
            state.countryFormatCaches.push({ key: key, value: countryFormat, loading: false });
        }
    },
    setRetry(state, key) {
        const existing = state.countryFormatCaches.find(cfc => cfc.key === key);
        if (!!existing) {
            existing.retry = true;
            existing.loading = false;
        }
    }
}

const actions = {
    getCountryFormat({ commit }, { key, payload }) {
        return new Promise((resolve, reject) => {
            commit('setLoading', { key: key, loading: true });
            WebApi.get('CountryFormat?' + new URLSearchParams(payload))
                .then(response => {
                    commit('setCountryFormat', { key: key, countryFormat: response.data });
                    resolve(response);
                })
                .catch(error => {
                    if (ErrorHelper.isNotFound(error)) {
                        commit('setLoading', { key: key, loading: false });
                        resolve(false);
                    } else {
                        commit('setRetry', key);
                        reject(error);
                    }
                });
        });
    },
    getCountryFormatBySiteId({ commit }, { key, siteId, payload} ) {
        return new Promise((resolve, reject) => {
            commit('setLoading', { key: key, loading: true });
            WebApi.get('Portal/' + siteId + '/CountryFormat?' + new URLSearchParams(payload))
                .then(response => {
                    commit('setCountryFormat', { key: key, countryFormat: response.data });
                    resolve(response);
                })
                .catch(error => {
                    if (ErrorHelper.isNotFound(error)) {
                        commit('setLoading', { key: key, loading: false });
                        resolve(false);
                    } else {
                        commit('setRetry', key);
                        reject(error);
                    }
                });
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
